import { ImagesHeaderMenuSvg } from '@/assets/images_header.assets';
import DefaultButton from '@/components/common/default/DefaultButton';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import { MobileMenuCurrentSubMenuActive } from '@/types/layout';
import MobileMenuDialog from './MobileMenuDialog/MobileMenuDialog';
import { usePathname } from 'next/navigation';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { HeaderEnum } from '@/types/translations/HeaderEnum';
export default function MobileMenu() {
  const { translate } = useTypedTranslation<HeaderEnum>('header');
  const pathname = usePathname();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [currentSubMenuActive, setCurrentSubMenuActive] =
    useState<MobileMenuCurrentSubMenuActive>('none');

  useEffect(() => {
    setMobileMenuOpen(false);
    setCurrentSubMenuActive('none');
  }, [pathname]);

  return (
    <>
      <DefaultButton
        aria-label={translate(HeaderEnum['common.open_menu'])}
        onClick={() => setMobileMenuOpen(true)}
      >
        <Image
          src={ImagesHeaderMenuSvg}
          alt="menu"
          width={28}
          height={19.200000762939453}
        />
      </DefaultButton>

      <MobileMenuDialog
        open={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
        currentSubMenuActive={currentSubMenuActive}
        setCurrentSubMenuActive={setCurrentSubMenuActive}
      />
    </>
  );
}
